<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        ویرایش وعده غذایی
      </h4>
    </b-card-header>
    <b-card-body>
      <validation-observer
        #default="handleSubmit"
        ref="refFormObserver"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col md="4">
              <validation-provider
                #default="validationContext"
                name="نام وعده"
                rules="required"
              >
                <b-form-group>
                  <label for="name">
                    <feather-icon
                      icon="FeatherIcon"
                    />
                    نام وعده
                  </label>
                  <b-form-input
                    id="name"
                    v-model="name"
                    placeholder="نام وعده را وارد نمایید"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="isActive" />
                <b-form-checkbox
                  id="isActive"
                  v-model="isActive"
                  checked="true"
                  name="check-button"
                  class="custom-control-success"
                  switch
                >
                  فعال
                </b-form-checkbox>
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group
                label="فعال از ساعت"
                description="این ساعت به صورت پیش فرض برای تمام روزها در نظر گرفته می شود . برای تغییر یک روز خاص هنگام ساخت غذای روز اقدام کنید."
              >
                <date-picker
                  v-model="fromTime"
                  type="time"
                  display-format="HH:mm"
                  format="HH:mm"
                  placeholder="لطفاً ساعت پیش فرض را وارد کنید "
                  clearable
                />

              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="فعال تا ساعت"
                description="این ساعت به صورت پیش فرض برای تمام روزها در نظر گرفته می شود . برای تغییر یک روز خاص هنگام ساخت غذای روز اقدام کنید."
              >
                <date-picker
                  v-model="toTime"
                  type="time"
                  :min="fromTime"
                  display-format="HH:mm"
                  format="HH:mm"
                  placeholder="لطفاً ساعت پیش فرض را وارد کنید "

                  clearable
                />

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-overlay :show="organizationList.length === 0">
                <b-form-group>
                  <label for="role">
                    <feather-icon
                      icon="PocketIcon"
                    />
                    واحدهای سازمانی مجاز رزرو
                  </label>
                  <v-select
                    v-model="organizations"
                    multiple
                    dir="rtl"
                    label="name"
                    :options="organizationList"
                    :reduce="organization => organization.id"
                    :close-on-select="false"
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="users">
                  <feather-icon
                    icon="UsersIcon"
                  />
                  کاربران مجاز رزرو
                </label>
                <b-overlay :show="usersList.length === 0">
                  <v-select
                    v-model="users"
                    multiple
                    dir="rtl"
                    label="name"
                    :options="usersList"
                    :reduce="receiver => receiver.id"
                    :close-on-select="false"
                  />
                </b-overlay>
              </b-form-group>
            </b-col>
          </b-row>

        </b-form>
      </validation-observer>
      <button
        class="btn btn-info mt-2"
        @click="updateUser"
      >
        ویرایش وعده غذایی
      </button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormCheckbox, BFormInvalidFeedback,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import VSelect from 'vue-select'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'MealUpdate',
  components: {
    VSelect,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      name: '',
      isActive: true,
      fromTime: null,
      toTime: null,
      users: [],
      usersList: [],
      organizations: [],
      organizationList: [],
    }
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
  mounted() {
    this.getOrganizations()
    this.getUsers()
    this.getMeal()
  },
  methods: {
    getMeal() {
      this.$http.get(`meals/${this.$route.params.id}`)
        .then(({ data }) => {
          if (data.status) {
            this.name = data.meal.name
            this.isActive = data.meal.isActive
            this.toTime = data.meal.toTime
            this.fromTime = data.meal.fromTime
            this.organizations = data.meal.organizations
            this.users = data.meal.users
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت وعده غذایی  با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    updateUser() {
      this.$refs.refFormObserver.validate()
        .then(success => {
          if (success) {
            this.$http.put(`meals/${this.$route.params.id}`, {
              name: this.name,
              is_active: this.isActive,
              from_time: this.fromTime,
              to_time: this.toTime,
              users: this.users,
              organizations: this.organizations,
            })
              .then(({ data }) => {
                if (data.status) {
                  this.$bvToast.toast('وعده غذایی  با موفقیت ویرایش شد', {
                    title: 'موفقیت',
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                  })
                } else {
                  this.$bvToast.toast(data.message ?? 'در ایجاد وعده غذایی  خطایی رخ داده', {
                    title: 'حطا',
                    toaster: 'b-toaster-top-right',
                    variant: 'danger',
                  })
                }
              })
              .catch(error => {
                this.$bvToast.toast(error.response.data.message ?? error.message, {
                  title: 'خطا در دریافت اطلاعات',
                  toaster: 'b-toaster-top-right',
                  variant: 'danger',
                })
              })
          }
        })
    },
    getOrganizations() {
      this.$http.get('organizations')
        .then(({ data }) => {
          this.organizationList = data.organizations
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
    getUsers() {
      this.$http.get('user/list')
        .then(({ data }) => {
          this.usersList = data
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
  },
  setup() {
    const {
      getValidationState,

    } = formValidation(name)

    return {
      getValidationState,
    }
  },
}
</script>

<style>

</style>
